/* eslint-disable no-const-assign */
/* eslint-disable react-hooks/exhaustive-deps */
import { Grid, Typography, useMediaQuery, useTheme } from '@mui/material'
import React, { useState } from 'react'
import Servicescarosel from '../../Component/Carosel/Services_Carosel'
import FacultyAchievements from '../../Component/Departments/Achivements_components/Achivements'
import SubjectList from '../../Component/Departments/Achivements_components/Subjectlist'
import Events from '../Events/Events'
import HS from '../HS/HS'
import MissionVission from '../MV/MV'
import HCarosel from '../../Component/Carosel/Header_Carosel'
import CardActions from '@mui/material/CardActions'
import {
  CardActionArea,
  CardContent,
  CardMedia,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  Button,
  Box,
} from '@mui/material'
import twitterIcon from '../../Assets/Icons/Social_icon_twitter.svg'
import linkedinIcon from '../../Assets/Icons/Social_icon_linkedin.svg'
import PlantIcon1 from '../../Assets/Icons/Plant Clasification1.svg'
import Arrow_icon from '../../Assets/Icons/Black_Arrow.svg'
import PlantIcon2 from '../../Assets/Icons/Plant Clasification2.svg'
import { useNavigate, useLocation } from 'react-router-dom'
import College_Data from '../../Assets/JSON/MV.json'
import {
  useComponentDidMount,
  useComponentDidUpdate,
} from '../../Component/utils'

const Department = (props) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'))

  const navigate = useNavigate()
  const location = useLocation()
  const College_DATA = location?.state?.College_details?.Department
  const [Selected_College_Data, setSelected_College_Data] = useState({})
  const [openDialog, setOpenDialog] = useState(false)
  const [selectedPB, setSelectedPB] = useState(null)

  useComponentDidMount(() => {
    Get_College_Data()
  })

  useComponentDidUpdate(() => {
    Get_College_Data()
  })

  const Get_College_Data = () => {
    let filterkey = 'null'
    if (
      College_DATA?.title === 'BCOM Computer Applications' ||
      College_DATA?.title === 'Business Anlytics'
    ) {
      filterkey = 'BCOM General'
    } else {
      filterkey = College_DATA?.title
    }
    let selected_College_data = College_Data.College_Department_Details?.find(
      (items) => items.department === filterkey
    )
    setSelected_College_Data(selected_College_data)
  }

  const handleCloseDialog = () => {
    setOpenDialog(false)
  }

  const handleOpenDialog = (pb) => {
    setSelectedPB(pb)
    setOpenDialog(true)
  }

  const handlePlantGridClick = () => {
    navigate(`/department/b.sc/botany/plant-details/11/Acalypha-Ostryifolia`)
  }

  return (
    <Box component="section" sx={{ overflowX: 'hidden' }}>
      {Selected_College_Data === undefined ? (
        <Box sx={{ m: 5, py: 5, textAlign: 'center' }}>
          <Typography variant="h4">NO DATA FOUND</Typography>
        </Box>
      ) : (
        <Box>
          <Box sx={{ position: 'relative' }}>
            <Box>
              <HCarosel />
            </Box>
            <Box
              sx={{
                position: 'absolute',
                bottom: 0,
                left: 0,
                ml: isMobile ? 2 : 4,
                mb: isMobile ? 2 : 4,
                color: 'white',
              }}
            >
              <Typography
                variant="h4"
                sx={{
                  fontSize: isMobile ? '1.5rem' : '2.125rem',
                  lineHeight: 1.2,
                }}
              >
                Welcome to <br />
                {College_DATA?.title === 'BCOM General'
                  ? 'Department of Commerce'
                  : `Department of ${College_DATA?.title}`}
              </Typography>
            </Box>
          </Box>

          <Box>
            {Selected_College_Data?.MissionVission &&
              Selected_College_Data?.MissionVission?.Mission.discreption !==
                '' && (
                <Box>
                  <MissionVission
                    MV_DATA={Selected_College_Data?.MissionVission}
                  />
                </Box>
              )}

            {Selected_College_Data?.HOD_Message &&
              Selected_College_Data?.HOD_Message.discreption !== '' && (
                <Box>
                  <HS HS_DATA={Selected_College_Data?.HOD_Message} />
                </Box>
              )}

            {Selected_College_Data?.FacultyData &&
              Selected_College_Data?.FacultyData.Faculty.length > 0 && (
                <Box sx={{ maxWidth: 'lg', mx: 'auto', px: isMobile ? 2 : 4 }}>
                  <Box sx={{ my: 4, textAlign: 'center' }}>
                    <Typography
                      variant="h2"
                      sx={{ fontSize: isMobile ? '1.75rem' : '2rem' }}
                    >
                      {Selected_College_Data?.FacultyData.title}
                    </Typography>
                  </Box>
                  <Grid container spacing={isMobile ? 1 : 2}>
                    {Selected_College_Data?.FacultyData.Faculty.map(
                      (items, index) => (
                        <Grid
                          item
                          xs={12}
                          sm={6}
                          md={4}
                          lg={3}
                          key={index}
                          sx={{ px: isMobile ? 1 : 2, my: 1 }}
                          onClick={() => handleOpenDialog(items)}
                        >
                          <CardActionArea>
                            <CardMedia
                              component="img"
                              height="200"
                              image={
                                items.image === ''
                                  ? 'https://dbraeiassetmanagement.blob.core.windows.net/dbraimt/prod/home/Placeholders/Placeholder_Image.jpg'
                                  : items.image
                              }
                              alt="No Image"
                              onError={(e) =>
                                (e.target.src =
                                  'https://dbraeiassetmanagement.blob.core.windows.net/dbraimt/prod/home/Placeholders/Placeholder_Image.jpg')
                              }
                              sx={{
                                height: isMobile ? 160 : 200,
                                objectFit: 'cover',
                              }}
                            />
                            <CardContent sx={{ m: 0, py: 2, px: 0 }}>
                              <Typography
                                sx={{ m: 0 }}
                                gutterBottom
                                variant="h6"
                                component="div"
                              >
                                {items.Name}
                              </Typography>
                              <Typography
                                gutterBottom
                                variant="body1"
                                color="primary"
                                sx={{ fontSize: '15px' }}
                              >
                                {items.designation}
                              </Typography>
                              <Typography
                                variant="body2"
                                color="text.secondary"
                                sx={{
                                  display: '-webkit-box',
                                  WebkitLineClamp: 2,
                                  WebkitBoxOrient: 'vertical',
                                  overflow: 'hidden',
                                }}
                              >
                                {items.descerption}
                              </Typography>
                            </CardContent>
                            <CardActions
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'flex-start',
                                px: 0,
                              }}
                            >
                              <img
                                src={twitterIcon}
                                alt="Twitter"
                                style={{ marginRight: 12 }}
                              />
                              <img src={linkedinIcon} alt="LinkedIn" />
                            </CardActions>
                          </CardActionArea>
                        </Grid>
                      )
                    )}
                  </Grid>
                </Box>
              )}

            {Selected_College_Data?.Faculty_Achievements &&
              Selected_College_Data?.Faculty_Achievements.length > 0 && (
                <FacultyAchievements
                  facultyAchievements={
                    Selected_College_Data.Faculty_Achievements
                  }
                />
              )}

            {Selected_College_Data?.Service_Data && (
              <Box>
                <Servicescarosel />
              </Box>
            )}

            {Selected_College_Data?.Student_Achievements &&
              Selected_College_Data?.Student_Achievements.length > 0 && (
                <Box sx={{ maxWidth: 'lg', mx: 'auto', px: isMobile ? 2 : 4 }}>
                  <Box sx={{ my: 4 }}>
                    <Typography
                      variant="h2"
                      sx={{ fontSize: isMobile ? '1.75rem' : '2rem' }}
                    >
                      Student Achievement
                    </Typography>
                  </Box>
                  <Grid container spacing={isMobile ? 1 : 2}>
                    <Grid item xs={12} md={6} sx={{ px: 1, my: 1 }}>
                      <CardActionArea>
                        <CardMedia
                          component="img"
                          height="250"
                          image={
                            Selected_College_Data.Student_Achievements[0]
                              ?.image === ''
                              ? 'https://dbraeiassetmanagement.blob.core.windows.net/dbraimt/prod/home/Placeholders/Placeholder_Image.jpg'
                              : Selected_College_Data.Student_Achievements[0]
                                  ?.image
                          }
                          alt="No Image"
                          onError={(e) =>
                            (e.target.src =
                              'https://dbraeiassetmanagement.blob.core.windows.net/dbraimt/prod/home/Placeholders/Placeholder_Image.jpg')
                          }
                          sx={{
                            height: isMobile ? 200 : 250,
                            objectFit: 'cover',
                          }}
                        />
                        <CardContent sx={{ m: 0, py: 2, px: 0 }}>
                          <Typography
                            gutterBottom
                            variant="body2"
                            color="primary"
                            sx={{ fontSize: '12px' }}
                          >
                            {
                              Selected_College_Data.Student_Achievements[0]
                                .achived_date
                            }
                          </Typography>
                          <Typography
                            sx={{ m: 0 }}
                            gutterBottom
                            variant="h6"
                            component="div"
                          >
                            {
                              Selected_College_Data.Student_Achievements[0]
                                .title
                            }
                          </Typography>
                          <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{
                              display: '-webkit-box',
                              WebkitLineClamp: 3,
                              WebkitBoxOrient: 'vertical',
                              overflow: 'hidden',
                            }}
                          >
                            {
                              Selected_College_Data.Student_Achievements[0]
                                .description
                            }
                          </Typography>
                        </CardContent>
                        <CardActions sx={{ px: 0, flexWrap: 'wrap' }}>
                          {Selected_College_Data.Student_Achievements[0]
                            .avchived_In > 0 &&
                            Selected_College_Data.Student_Achievements[0].avchived_In.map(
                              (items, index) => (
                                <Box
                                  key={index}
                                  sx={{
                                    px: 2,
                                    py: 1,
                                    bgcolor: 'action.selected',
                                    borderRadius: 1,
                                    m: 0.5,
                                  }}
                                >
                                  {items}
                                </Box>
                              )
                            )}
                        </CardActions>
                      </CardActionArea>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Grid container spacing={isMobile ? 1 : 2}>
                        {Selected_College_Data.Student_Achievements.slice(
                          1,
                          3
                        ).map((items, index) => (
                          <React.Fragment key={index}>
                            <Grid item xs={12} sm={6} sx={{ px: 1, my: 1 }}>
                              <CardActionArea>
                                <CardMedia
                                  component="img"
                                  height="200"
                                  image={
                                    items.image === ''
                                      ? 'https://dbraeiassetmanagement.blob.core.windows.net/dbraimt/prod/home/Placeholders/Placeholder_Image.jpg'
                                      : items.image
                                  }
                                  onError={(e) =>
                                    (e.target.src =
                                      'https://dbraeiassetmanagement.blob.core.windows.net/dbraimt/prod/home/Placeholders/Placeholder_Image.jpg')
                                  }
                                  alt="No Image"
                                  sx={{
                                    height: isMobile ? 160 : 200,
                                    objectFit: 'cover',
                                  }}
                                />
                              </CardActionArea>
                            </Grid>
                            <Grid item xs={12} sm={6} sx={{ px: 1, my: 1 }}>
                              <CardActionArea>
                                <CardContent sx={{ m: 0, py: 2, px: 0 }}>
                                  <Typography
                                    gutterBottom
                                    variant="body2"
                                    color="primary"
                                    sx={{ fontSize: '12px' }}
                                  >
                                    {items.achived_date}
                                  </Typography>
                                  <Typography
                                    sx={{ m: 0 }}
                                    gutterBottom
                                    variant="h6"
                                    component="div"
                                  >
                                    {items.title}
                                  </Typography>
                                  <Typography
                                    variant="body2"
                                    color="text.secondary"
                                    sx={{
                                      display: '-webkit-box',
                                      WebkitLineClamp: 3,
                                      WebkitBoxOrient: 'vertical',
                                      overflow: 'hidden',
                                    }}
                                  >
                                    {items.description}
                                  </Typography>
                                </CardContent>
                                <CardActions sx={{ px: 0, flexWrap: 'wrap' }}>
                                  {items.avchived_In &&
                                    items.avchived_In.map((item, i) => (
                                      <Box
                                        key={i}
                                        sx={{
                                          px: 2,
                                          py: 1,
                                          bgcolor: 'action.selected',
                                          borderRadius: 1,
                                          m: 0.5,
                                        }}
                                      >
                                        {item}
                                      </Box>
                                    ))}
                                </CardActions>
                              </CardActionArea>
                            </Grid>
                          </React.Fragment>
                        ))}
                      </Grid>
                    </Grid>
                  </Grid>
                </Box>
              )}

            {Selected_College_Data?.News_Events &&
              Selected_College_Data?.News_Events.length > 0 && (
                <Box>
                  <Events
                    Event_DATA={Selected_College_Data?.News_Events}
                    title={Selected_College_Data?.title}
                  />
                </Box>
              )}

            {Selected_College_Data?.Subjectdata?.subject.length > 0 && (
              <SubjectList
                subjects={Selected_College_Data.Subjectdata.subject}
              />
            )}

            {College_DATA?.title === 'Botany' && (
              <Box
                sx={{
                  maxWidth: 'lg',
                  mx: 'auto',
                  py: 5,
                  px: isMobile ? 2 : 4,
                }}
                onClick={handlePlantGridClick}
              >
                <Grid
                  container
                  spacing={2}
                  sx={{
                    backgroundColor: '#E2FFE5',
                    borderRadius: '5px',
                    alignItems: 'center',
                    cursor: 'pointer',
                  }}
                >
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    sx={{ py: 5, px: isMobile ? 3 : 5 }}
                  >
                    <Typography variant="h5" sx={{ fontWeight: 500 }}>
                      {Selected_College_Data?.Plant_Clasifications?.title}
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{ display: 'flex', alignItems: 'center' }}
                    >
                      Check Out
                      <img
                        style={{ paddingLeft: 8 }}
                        src={Arrow_icon}
                        alt="Arrow"
                      />
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    sm={3}
                    md={4}
                    sx={{
                      display: 'flex',
                      justifyContent: isMobile ? 'flex-start' : 'center',
                      py: 0,
                    }}
                  >
                    <img
                      src={PlantIcon1}
                      alt="Plant 1"
                      style={{ maxWidth: '100%', height: 'auto' }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    sm={3}
                    md={4}
                    sx={{
                      display: 'flex',
                      justifyContent: isMobile ? 'flex-end' : 'flex-end',
                      py: 0,
                    }}
                  >
                    <img
                      src={PlantIcon2}
                      alt="Plant 2"
                      style={{ maxWidth: '100%', height: 'auto' }}
                    />
                  </Grid>
                </Grid>
              </Box>
            )}
          </Box>
        </Box>
      )}

      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        fullScreen={isMobile}
      >
        <DialogTitle>{selectedPB ? selectedPB.title : ''}</DialogTitle>
        <DialogContent>
          <CardMedia
            component="img"
            height="340"
            image={selectedPB ? selectedPB.image : ''}
            alt="PB Image"
            sx={{
              width: '100%',
              height: isMobile ? 'auto' : 340,
              objectFit: 'cover',
              mb: 2,
            }}
          />
          <Typography variant="h5" color="text.secondary">
            {selectedPB ? selectedPB.Name : ''}
          </Typography>
          <CardActions
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-start',
              px: 0,
              py: 2,
            }}
          >
            <img src={twitterIcon} alt="Twitter" style={{ marginRight: 12 }} />
            <img src={linkedinIcon} alt="LinkedIn" />
          </CardActions>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>Close</Button>
        </DialogActions>
      </Dialog>
    </Box>
  )
}

export default Department
